<app-pcbread-crumb [data]="'warehouse,InventoryTransfer'"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<ng-template #AddInventoryTransferModal let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "InventoryTransfer" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="input-box stock-box ms-1 p-2 mb-2">
        <div class="input-box-title-box px-2">
          <span>
            {{ "stockInformation" | translate }}
          </span>
        </div>
        <div class="row p-3">
          <div class="col-6 p-2 py-0">
            <div class="edit-form">
              <label class="form-label" for="destinationStock">
                {{ "sourceStocks" | translate }}</label
              >
              <select
                id="sourceStocks"
                class="form-select"
                data-allow-clear="true"
                (change)="filterStocks()"
                [(ngModel)]="newItem.sourceStockId"
                [disabled]="newItem.status > -1||newItem.status==-2"
              >
                <option *ngFor="let stock of stockList" [ngValue]="stock.id">
                  {{ stock.persianName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-6 p-2 py-0">
            <div class="edit-form">
              <label class="form-label" for="destinationStock">
                {{ "destinationStock" | translate }}
              </label>
              <div class="validation-alert">
                <p>
                  {{ destinationMessage }}
                </p>
              </div>
              <select
                id="destinationstock"
                class="form-select input-select-text py-2 Focusable iner-Focusable"
                [(ngModel)]="newItem.destinationStockId"
                [disabled]="newItem.status > -1||newItem.status==-2"
              >
                <option Value="">
                  {{ "SelectOne" | translate }}
                </option>
                <option
                  *ngFor="let stock of secondStockList"
                  [ngValue]="stock.id"
                >
                  {{ stock.persianName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12 p-2 py-0">
            <div class="edit-form">
              <label for="description" class="form-label m-0"
                >{{ "description" | translate }}:</label
              >
              <textarea
                id="description"
                type="text"
                class="form-control Focusable"
                [(ngModel)]="newItem.description"
                placeholder="{{ 'description' | translate }}"
                [disabled]="newItem.status > -1||newItem.status==-2"
              >
              </textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="row input-box drug-information ms-1 p-2 mb-2 mt-3">
        <div class="input-box-title-box px-2">
          <span>
            {{ "DrugInfo" | translate }}
          </span>
        </div>
        <div class="set-modal">
          <div class="col-12 mt-3">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col">{{ "Row" | translate }}</th>
                  <th scope="col">{{ "drugName" | translate }}</th>
                  <th scope="col">{{ "count" | translate }}</th>
                  <th scope="col">{{ "expireDate" | translate }}</th>
                  <th scope="col" *ngIf="!justShow"></th>
                </tr>
              </thead>
              <tbody id="rows">
                <tr *ngFor="let Item of newItem.details; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ Item.drugName }}</td>
                  <td>{{ Item.count | dataType : "" }}</td>
                  <td>{{ Item.expireDate | dataType : "" }}</td>
                  <td
                    class="d-flex justify-content-evenly align-items-center"
                    *ngIf="!justShow"
                  >
                    <button
                      type="button"
                      class="delete-icon-on-table btn btn-icon btn-outline-danger"
                      (click)="remove(Item)"
                      ngbTooltip="{{ 'Delete' | translate }}"
                    >
                      <i class="fa-regular fa-trash-can"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-icon btn-outline-primary go-to-next"
                      (click)="editDrug(Item, i)"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row" *ngIf="!justShow">
          <div class="col-5 p-2 py-0">
            <div class="edit-form">
              <label class="form-label" for="Number">
                {{ "drugBrandName" | translate }}
              </label>
              <div
                class="validation-alert-pc-modal"
                *ngIf="newDrug.drugNameHint != null"
              >
                <p>
                  {{ newDrug.drugNameHint }}
                </p>
              </div>
              <form [formGroup]="drugSearchForm">
                <input
                  id="drugBrandName"
                  type="text"
                  autocomplete="off"
                  appSelectOnFocus
                  formControlName="drugBrandName"
                  class="form-control Focusable iner-Focusable search-input-box"
                  placeholder="{{ 'PleaseInputDrugName' | translate }}"
                  [ngClass]="{
                    'is-invalid': newDrug.drugNameHint != null
                  }"
                  [(ngModel)]="newDrug.drugName"
                  (ngModelChange)="searchDrug(newDrug.drugName)"
                />
              </form>
            </div>
            <app-search-box
              [data]="searchData"
              [addButton]="true"
              [fields]="searchFields"
              [urlName]="'columnsArray_InventoryDetails'"
              [paging]="searchPaging"
              [modalIsOpen]="modalIsOpen"
              (parentAction)="parentSearchAction($event)"
            >
            </app-search-box>
          </div>
          <div class="col-3 p-2 py-0">
            <div class="edit-form">
              <label class="form-label" for="Number">
                {{ "Count" | translate }}
              </label>
              <div
                class="validation-alert-pc-modal"
                *ngIf="newDrug.countHint != null"
              >
                <p>
                  {{ newDrug.countHint }}
                </p>
              </div>
              <input
                id="Count"
                type="text"
                autocomplete="off"
                appSelectOnFocus
                class="form-control input-one Focusable iner-Focusable"
                [ngClass]="{
                  'is-invalid': newDrug.countHint != null
                }"
                [(ngModel)]="newDrug.count"
              />
            </div>
          </div>
          <div class="col-3 p-2 py-0">
            <div class="edit-form">
              <label for="expireDate" class="form-label" for="expireDate">
                {{ "ExpireDate" | translate }}
              </label>
              <div
                class="validation-alert-pc-modal"
                *ngIf="newDrug.expireDateHint != null"
              >
                <p>
                  {{ newDrug.expireDateHint }}
                </p>
              </div>
              <div class="datepicker-box">
                <input
                  id="expireDate"
                  type="text"
                  autocomplete="off"
                  appSelectOnFocus
                  appConvertNumbers
                  class="form-control Focusable iner-Focusable"
                  [ngClass]="{
                    'is-invalid': newDrug.expireDateHint != null
                  }"
                  [ngModel]="newDrug.expireDate | dataType : 'justDate' : false"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="YYYY/MM/DD"
                  (ngModelChange)="
                    newDrug.expireDate = calendarService.TypeDate('expireDate')
                  "
                />
                <button
                  [ngbPopover]="popoverDatapickerexpireDate"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>
              </div>
              <ng-template #popoverDatapickerexpireDate>
                <app-data-picker
                  [(childProp)]="newDrug.expireDate"
                  (changeVariableMonth)="changeMonth($event)"
                ></app-data-picker>
              </ng-template>
            </div>
          </div>
          <div class="col-1 mt-4 p-2">
            <button
              type="button"
              class="btn btn-icon btn-outline-success go-to-next p-1"
              (click)="addDrugToList()"
            >
              <i class="far fa-save"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer border-top justify-content-center p-3">
    <ng-container  *ngIf="newItem.status != -2">
      <button
        type="button"
        class="btn btn-primary"
        (click)="saveInventoryTransfer()"
        *ngIf="newItem.status == -1"
      >
        {{ "Save" | translate }}
      </button>
      
      <button
        type="button"
        class="btn btn-primary"
        (click)="sendTransfer()"
        *ngIf="newItem.status == 0"
      >
        {{ "Send" | translate }}
      </button>

      <button
        type="button"
        class="btn btn-primary"
        (click)="deliveryTransfer()"
        *ngIf="newItem.status == 2"
      >
        {{ "Delivery" | translate }}
      </button>

      <button
        type="button"
        class="btn btn-label-secondary"
        (click)="clearEditItem()"
        aria-label="Close"
      >
        {{ "Clear" | translate }}
      </button>
    </ng-container>
  </div>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</ng-template>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  (childEvent)="parentAction($event)"
  [inputModel]="confirmModal"
></app-pcconfrim-modal>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>
